import { NO_PANEL_ELEMENTS } from 'components/Editor/EditorElements/elements.config'
import { AppMode } from 'services/Store/Project/enums'
import { useProjectContext } from 'services/Store/Project/hooks'
import {
  getBlock,
  getEditorMode,
  isMultipleNodes,
  getNodeId,
  getToolbar,
  isBlocksMultiSelect,
} from 'services/Store/Project/selectors'

import { getElementByNodeId } from '../EditorContext/selectors/block'
import { BlockActionUiEnum, EditorActionUiEnum } from '../types'

export const useActiveToolbar = () => {
  const editorMode = useProjectContext(getEditorMode)
  const toolbar = useProjectContext(getToolbar)
  const block = useProjectContext(getBlock)
  const nodeId = useProjectContext(getNodeId)
  const isMultipleBlock = useProjectContext(isBlocksMultiSelect)
  const isMultipleNode = useProjectContext(isMultipleNodes)

  if (editorMode === AppMode.comment) {
    return EditorActionUiEnum.COMMENTS_PANEL
  }

  if (toolbar.taskTab) {
    return EditorActionUiEnum.TASKS_PANEL
  }
  const element = nodeId && block && getElementByNodeId(block, nodeId)

  if (editorMode === AppMode.fill) {
    if (element && !NO_PANEL_ELEMENTS.includes(element.type) && !isMultipleBlock) {
      return EditorActionUiEnum.ELEMENT_PANEL
    }
    if ((block?.uuid && !toolbar.sectionSettings) || isMultipleBlock) {
      return BlockActionUiEnum.SETTINGS
    }
  }
  if (toolbar.sectionSettings || !block) {
    return EditorActionUiEnum.SECTION_SETTINGS
  }

  if (editorMode === AppMode.pro) {
    if ((element || nodeId || isMultipleNode) && !isMultipleBlock) {
      return EditorActionUiEnum.ELEMENT_PANEL
    }

    return BlockActionUiEnum.SETTINGS
  }

  return EditorActionUiEnum.SECTION_SETTINGS
}
